import { useNavigate, useSearchParams } from 'react-router-dom';

import ReferralForm from '@/forms/ReferralForm';
import useNavigateToPage from '@/hooks/useNavigateToPage';
import Container from '@/ui/components/Container';

const NewReferral = () => {
  const { navigateToProfileWithId } = useNavigateToPage();

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const personId = searchParams.get('personId');

  const onSuccess = () => {
    if (!personId) return navigate(-1);

    navigateToProfileWithId(personId);
  };

  return (
    <Container type="page">
      <ReferralForm onSuccess={onSuccess} />
    </Container>
  );
};

export default NewReferral;
